<template>
    <div class="py-6 px-1 bg-white border-b border-black">
        <!-- First name input field -->
        <first-name-field class="FIRST_NAME_REQUIRED" v-model="firstName"/>

        <!-- Last name input field -->
        <last-name-field class="LAST_NAME_REQUIRED" v-model="lastName"/>

        <gifting-address-form v-model="deliveryAddress"/>

        <delivery-address-property-type-field
            :require="true"
            class="mt-8 PROPERTY_TYPE_REQUIRED"
            v-model="propertyType"/>

        <delivery-instructions-field
            v-model="deliveryComment"
            :label="$t('GIFTING_ADDRESS_FORM_HOW_TO_FIND')"/>

        <div class="w-full p-2" v-if="errorHandler.getAllErrors()">
            <ul class="error list-disc text-center">
                <li v-for="(errorMsg, key) in errorHandler.getAllErrors()" :key="key">
                    <span class="font-bold capitalize" v-text="key"></span>:
                    <span class="font-normal" v-text="$t(errorMsg)"></span>
                </li>
            </ul>
        </div>

        <div class="w-full md:flex pt-4 pb-2 px-2">
            <div class="w-full md:w-1/2 px-0 md:px-1 py-1 md:py-0">
                <button
                    class="w-1/2 btn btn--secondary btn--auto-width btn--full-width"
                    @click="close" v-text="$t('BUTTON_CANCEL')"></button>
            </div>
            <div class="w-full md:w-1/2 px-0 md:px-1 py-1 md:py-0">
                <submit-button
                    class="btn--full-width"
                    @click="submit"
                    :hoverable="false"
                    :processing="formProcessing"
                    v-text="$t('CREATE_GIFTING_ADDRESS_FORM_CREATE')"></submit-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import AddressService from '@/services/logistics/AddressService';
import LastNameField from '@/components/forms/fields/LastNameField';
import SubmitButton from '@/components/forms/buttons/SubmitButton';
import FirstNameField from '@/components/forms/fields/FirstNameField';
import GiftingAddressForm from '@/components/forms/addresses/GiftingAddressForm';
import DeliveryInstructionsField from '@/components/forms/fields/DeliveryInstructionsField';
import DeliveryAddressPropertyTypeField from '@/components/forms/fields/LegacyDeliveryAddressPropertyTypeField';

export default {
    name: 'CreateGiftingAddressForm',
    components: {
        LastNameField,
        FirstNameField,
        SubmitButton,
        DeliveryAddressPropertyTypeField,
        DeliveryInstructionsField,
        GiftingAddressForm,
    },
    data() {
        return {
            firstName: null,
            lastName: null,
            deliveryAddress: null,
            deliveryComment: null,
            propertyType: null,
            errorHandler: new ErrorResponseHandler(),
            formProcessing: false,
        };
    },
    computed: {
        ...mapGetters({
            user: 'account/getUser',
        }),
        areAllFormFieldsValid() {
            return !this.$v.$invalid;
        },
        addressPropertyLabel() {
            return this.$t('CREATE_GIFTING_ADDRESS_FORM_NO_ONE_HOME');
        },
        validationErrors() {
            return Object.values(this.errorHandler.getAllErrors());
        },
    },
    methods: {
        close() {
            this.$emit('closed');
        },

        submit() {
            this.toggleFormProcessing();
            this.validateInput();
        },

        validateInput() {
            this.$v.$touch();

            this.areAllFormFieldsValid ? this.handleCreatingGiftingAddressViaApi() : this.forceRequiredValidationMessagesVisibility();
        },

        handleCreatingGiftingAddressViaApi() {
            let newAddress = {
                firstName: this.firstName,
                lastName: this.lastName,
                houseNumber: this.deliveryAddress ? this.deliveryAddress.houseNumber : '',
                address1: this.deliveryAddress ? this.deliveryAddress.addressLine1 : '',
                address2: this.deliveryAddress ? this.deliveryAddress.addressLine2 : '',
                city: this.deliveryAddress ? this.deliveryAddress.city : '',
                postcode: this.deliveryAddress ? this.deliveryAddress.postcode : '',
                country: process.env.VUE_APP_COUNTRY_ISO,
                deliveryComment: this.deliveryComment,
                propertyType: this.propertyType,
            };

            let service = new AddressService();
            service.createGiftingAddress(newAddress, this.user.id)
                .then((response) => {
                    this.$store.commit('address/updateSelectedGiftingAddressId', response.data.properties.id);
                    this.$store.dispatch('gifting/fetchAvailableDeliveryDay', response.data.properties.postcode);
                    this.$emit('address-selected');
                })
                .catch(error => {
                    this.errorHandler.setResponse(error.response.data);
                    this.toggleFormProcessing();
                    if (this.validationErrors) {
                        this.$scrollTo(`.${this.validationErrors[0]}`, {
                            offset: -75,
                        });
                    }
                });
        },

        forceRequiredValidationMessagesVisibility() {
            this.toggleFormProcessing();
        },

        toggleFormProcessing() {
            this.formProcessing = !this.formProcessing;
        },
    },
    validations: {
    },
};
</script>
